module.exports = __webpack_public_path__ + "static/media/night-passed-icon.167ab3f5.png";